import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import VideoComponent from '@components/common/VideoComponent/VideoComponent';
import {
  BrowserType,
  PlatformType,
} from '@invideoio/web-shared/constants/common';
import { getAppropriateUrl } from '@invideoio/web-shared/utils/common';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Head from 'next/head';
import { VideoPosterType, VideoType } from '../../types/landing-page';

interface HeroVideoProps {
  video: VideoType;
  poster: VideoPosterType;
  platform: PlatformType;
  browser: BrowserType;
}

const HeroVideo = (props: HeroVideoProps) => {
  const { browser, video, poster, platform } = props;

  const posterURL = getAppropriateUrl(poster.url, browser, platform);

  return (
    <div className={ivclass('iv-hero-video iv-h-full')}>
      {video?.url && (
        <VideoComponent
          autoPlay
          loop
          muted
          width="100%"
          height="100%"
          poster={posterURL}
          loading="preload"
        >
          <source src={video?.url} />
        </VideoComponent>
      )}
      {!video?.url && posterURL && (
        <>
          {/* preloading this image to avoid LCP */}
          <Head>
            <link
              key={'__ivimg-' + posterURL}
              rel="preload"
              as="image"
              href={posterURL}
            />
          </Head>
          <ImageComponent
            elementype="native"
            src={posterURL}
            alt="hero"
            width="100%"
            height="100%"
            className="iv-w-full iv-h-full iv-object-contain iv-object-top iv-aspect-[1.548]"
          />
        </>
      )}
    </div>
  );
};

export default HeroVideo;
